import React from 'react';
import './css/entityInfoBar.css';

/**
 * Order Management's stage set (OMSALESORDERHEADER.STAGE code -> description).
 *
 * Exported rather than applied inside the bar: the codes are module-specific - WM's 'R' is
 * Ready To Receive/Pick/Staged, which OM has no equivalent for - so resolving a code to text is the
 * caller's job. WM already had its own map for exactly this reason.
 */
export const OM_STAGE_TEXT = {
    'A': 'Assigned - Effect Available',
    'C': 'Shipped/Completed - Effect Available',
    'F': 'Future - No Effect On Net Available',
    'L': 'Canceled - No Inventory Effect',
    'N': 'Pending - Effects Net Available',
    'P': 'Plan - No Inventory Effect',
    'Q': 'Quote - No Inventory Effect',
    'S': 'Picked/Staged - Effect Available',
};

export const formatInfoBarDate = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (isNaN(d)) return value;
    return (d.getMonth() + 1).toString().padStart(2, '0') + '/' + d.getDate().toString().padStart(2, '0') + '/' + d.getFullYear();
};

/**
 * The identifying header of a record, shown beside the page title on every tab except Primary (where
 * the same values are on the form itself).
 *
 * Every entry is supplied by the caller as `{ label, value, format }`, so the bar carries no
 * knowledge of what it is labelling. It started out with Trans # / Customer / Ship To / Ship Date /
 * Stage hard-coded, which meant any screen that was not a transaction got those labels whether they
 * applied or not - the Item Data Profile screen has none of those concepts.
 *
 * `format: 'date'` runs the value through the shared formatter, so a second date on the same bar
 * cannot drift into a different style.
 *
 * Entries with no value are dropped, so a caller can list a field unconditionally and let it
 * disappear when empty. The whole bar renders nothing when nothing is left.
 *
 * **Order matters.** The bar sheds trailing fields as the window narrows (see entityInfoBar.css), so
 * list the most identifying field first.
 */
const EntityInfoBar = ({ fields }) => {
    const shown = (fields || []).filter(f => f && f.label && f.value !== null && f.value !== undefined && f.value !== '');
    if (!shown.length) return null;

    return (
        <div className="entity-info-bar">
            {shown.map(({ label, value, format }) => (
                <span className="entity-info-bar__field" key={label}>
                    <span className="entity-info-bar__label">{label}:</span>
                    <span className="entity-info-bar__value">{format === 'date' ? formatInfoBarDate(value) : value}</span>
                </span>
            ))}
        </div>
    );
};

export default EntityInfoBar;
